<template>
  <div class="crowd-picker-content as-flex main-end cross-center">
    <el-cascader :options="formatOptions" :value="current_crowd" @change="handleChange"></el-cascader>
  </div>
</template>

<script>
import { clone } from "lodash";
export default {
  name: "crowdpicker",
  props: {
    options: {},
    current_crowd: {}
  },
  components: {},
  data() {
    return {
      formatOptions: []
    };
  },
  computed: {},
  methods: {
    handleChange(data) {
      this.$emit("crowdUpdate", data);
    }
  },
  watch: {
    options: {
      handler: function(to, from) {
        let formatOptions = Object.entries(to).map(item => {
          return {
            value: item[0],
            label: item[1].meta,
            children: Object.entries(item[1].sub).map(item => {
              return {
                value: item[0],
                label: item[1]
              };
            })
          };
        });
        this.formatOptions = formatOptions;
      },
      deep: true
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.crowd-picker-content {
  height: 100%;
  min-width: 200px;
}
/deep/ .el-cascader {
  line-height: 30px !important;
}
/deep/ .el-input__inner {
  color: #666666;
  // font-size: 10px;
  height: 30px;
  background-color: #fff !important;
  min-width: 200px;
}
/deep/ .el-input__suffix {
  display: flex;
  align-items: center;
}
/deep/ .el-input__icon {
  height: initial !important;
}
</style>

